import { MachineStatusIndicator } from '@/components/machines/machine-status-indicator'
import { StockIndicator } from '@/components/machines/stock-indicator'
import { Badge } from '@/components/ui/badge'
import { getMachineImage } from '@/lib/machines'
import { cn } from '@/lib/utils'

export interface MachineCardProps {
  name: string
  code: string
  type: string
  typeName: string
  status: string
  statusCategory: 'operational' | 'needs-attention' | 'offline'
  stock: number
  capacity: number
  emptySlots: number
  className?: string
}

export function MachineCard({
  name,
  code,
  type,
  typeName,
  status,
  statusCategory,
  stock,
  capacity,
  emptySlots,
  className,
}: MachineCardProps): React.ReactElement {
  return (
    <div
      className={cn(
        'flex flex-col gap-3 rounded-md border bg-white p-3 shadow-sm [--color-foreground:var(--color-light-foreground)] [--color-muted-foreground:var(--color-light-muted-foreground)] md:gap-8 md:p-5',
        className,
      )}
    >
      <div className="flex flex-row items-center gap-3 md:flex-col md:items-center md:gap-2">
        <div className="hidden size-20 shrink-0 items-center justify-center md:flex">
          <img
            src={getMachineImage(type)}
            alt={`${type} machine`}
            className="max-h-full max-w-full object-contain"
          />
        </div>
        <div className="flex min-w-0 flex-1 flex-col md:w-full md:flex-none">
          <span className="truncate text-base leading-6 font-semibold tracking-tight text-black md:text-lg">
            {name}
          </span>
          <div className="flex items-center justify-between gap-2">
            <span className="text-sm text-gray-500">#{code}</span>
            <Badge
              variant="secondary"
              className="rounded-sm bg-gray-100 text-xs tracking-wider text-black uppercase"
            >
              {typeName}
            </Badge>
          </div>
        </div>
      </div>
      <div className="mt-auto flex items-center justify-between">
        <StockIndicator stock={stock} capacity={capacity} />
        <MachineStatusIndicator
          status={status}
          statusCategory={statusCategory}
          emptySlots={emptySlots}
        />
      </div>
    </div>
  )
}
